/**
 * Feedback prompts for the corner card (components/FeedbackCard.tsx).
 * Kept out of the component file so pages can import requestFeedback
 * without dragging the component along.
 */

export type FeedbackPromptKey = 'onboarding' | 'portal';

export const PROMPTS: Record<FeedbackPromptKey, { title: string; sub: string; followUp: string }> = {
  /* Right after signup, asked for by Onboarding.tsx. */
  onboarding: {
    title: 'How was getting started?',
    sub: 'One tap. It helps us make this easier for the next person.',
    followUp: 'Anything that was confusing or slow?',
  },
  /* Everyone else. Shows once on the dashboard when nothing more
     specific was asked for and they've never answered or closed a card. */
  portal: {
    title: 'How is mediloop working for you?',
    sub: 'One tap. We read every answer.',
    followUp: 'Anything we should fix or add?',
  },
};

/** The prompt to fall back to when no page asked for one. */
export const DEFAULT_PROMPT: FeedbackPromptKey = 'portal';

/** Pages where the default prompt may appear. Not mid-case, not mid-upload. */
export const DEFAULT_PROMPT_PATHS = ['/', '/dashboard', '/bills'];

export const SESSION_KEY = 'ml_feedback_prompt';

export const doneKey = (userId: string, key: FeedbackPromptKey) =>
  `ml_feedback_done:${userId}:${key}`;

/** True if this user has answered or closed any card on this device. */
export function anyFeedbackDone(userId: string): boolean {
  try {
    const prefix = `ml_feedback_done:${userId}:`;
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) return true;
    }
    return false;
  } catch {
    return true;
  }
}

/** Ask the card to show the next time an authenticated page renders. */
export function requestFeedback(key: FeedbackPromptKey) {
  try {
    sessionStorage.setItem(SESSION_KEY, key);
  } catch {
    /* private mode, fine, we just don't ask */
  }
}
